import { useLocalizedField } from '@/hooks/useLocalizedField'
import { useLocale } from 'next-intl'

export default function HotelCard({ item }: any) {
    const locale = useLocale()
    const { getLocalizedField } = useLocalizedField()
    
    return (
        <a href={`/hotels/${item.slug}`} className="group cursor-pointer">
            <div className="flex flex-col gap-3 sm:gap-4" dir={locale === 'ar' ? 'rtl' : 'ltr'}>

                {/* Image with responsive height */}
                <div className="h-48 sm:h-60 md:h-72 overflow-hidden rounded-xl sm:rounded-2xl">
                    <img
                        src={item.vignette}
                        alt={getLocalizedField(item, 'name') ?? "Hotel"}
                        className="w-full h-full object-cover transition duration-500 group-hover:scale-110"
                    />
                </div>

                {/* Title & Address */}
                <div className="flex flex-col gap-1.5 sm:gap-2">
                    <h3 className="text-foreground text-lg sm:text-xl font-semibold truncate">
                        {getLocalizedField(item, 'name')}
                    </h3>

                    <p className="text-xs sm:text-sm text-foreground line-clamp-2">
                        {getLocalizedField(item, 'address')}
                    </p>
                </div>

            </div>
        </a>
    );
}
